import React from "react";
import { Typography, Stack, Box } from "@mui/material";
import { Instagram, LinkedIn } from "@mui/icons-material";
import { ReactComponent as DxaiFooterLogo } from "../assets/DxaiFooterLogo.svg";
import { ReactComponent as Location } from "../assets/Location.svg";
import { ReactComponent as Contact } from "../assets/Contact.svg";
import { ReactComponent as Email } from "../assets/Email.svg";

export default function Footer() {
  const openMap = () => {
    const address = encodeURIComponent(
      "284, A block, Shivalik, Malviya Nagar, Delhi - 110017"
    );
    window.open(
      `https://www.google.com/maps/search/?api=1&query=${address}`,
      "_blank"
    );
  };
  const callPhone = () => (window.location.href = "tel:011-4056-4117");
  const sendEmail = () => (window.location.href = "mailto:info@dxai.life");

  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      spacing={{ xs: 4, lg: 2 }}
      justifyContent={{ xs: "center", md: "space-between" }}
      alignItems={{ xs: "flex-start", md: "end" }}
      mt={4}
      mb={4}
      sx={{
        width: { lg: "82%", md: "78%", sm: "70%", xs: "70%" }, // Set width to 90% of the screen
        mx: "auto", // Center the Stack horizontally
      }}
      id="footer"
    >
      {/*  Section 1 */}
      <Stack
        alignItems={{ xs: "center", md: "center" }}
        direction={{ xs: "row", md: "column" }}
        width={{ xs: "100%", md: "auto" }}
        justifyContent={{ xs: "space-between", md: "start" }}
        sx={{
          height: {
            xs: "40px", // Small size for xs screens
            md: "120px", // Larger size for md and above
          },
          width: {
            xs: "auto", // Keep width proportional for xs
            md: "120px", // Fixed width for md and above
          },
        }}
      >
        <Box
          sx={{
            height: { xs: "70px", sm: "70px", md: "90px" }, // Responsive height
            width: { xs: "100px", sm: "120px", md: "150px" }, // Responsive width
            display: "flex",
            alignItems: "start",
            justifyContent: "flex-start", // Ensure it aligns to the left
          }}
        >
          <DxaiFooterLogo
            style={{
              height: "100%", // Ensures it takes parent's height
              width: "100%", // Ensures it takes parent's width
              objectFit: "contain", // Prevents stretching
            }}
          />
        </Box>
        <Stack direction="row" spacing={2} sx={{ paddingLeft: "0px" }}>
          <LinkedIn
            fontSize="large"
            onClick={() =>
              window.open(
                "https://www.linkedin.com/company/dxai-healthtech/about/",
                "_blank"
              )
            }
          />
          <Instagram
            fontSize="large"
            onClick={() =>
              window.open("https://www.instagram.com/dxai.life/", "_blank")
            }
          />
        </Stack>
      </Stack>
      {/* Section 2 */}
      <Stack order={{ xs: 3, sm: 3, md: 2, lg: 2 }}>
        <Typography
          variant="body2"
          textAlign="center"
          fontFamily="Poppins"
          fontWeight={"400"}
          fontSize={{
            lg: "12px",
            md: "12px",
            sm: "11.5px",
            xs: "11px",
          }}
        >
          © {new Date().getFullYear()} DxAi Healthtech Pvt. Ltd. All rights
          reserved
        </Typography>
        <Typography
          color="primary"
          textAlign="center"
          sx={{ cursor: "pointer" }}
          fontFamily={"Poppins"}
          fontWeight={"400"}
          fontSize={{
            lg: "12px",
            md: "12px",
            sm: "11.5px",
            xs: "11px",
          }}
        >
          Privacy Policy • Terms & Conditions
        </Typography>
      </Stack>
      {/* Section 3 */}
      <Stack
        alignItems={{ xs: "start", md: "flex-start" }}
        spacing={{
          xs: 3,
          sm: 2,
          md: 1.5,
        }}
        // width={{ xs: "90%", md: "auto" }}
        width={"180px"}
        order={{ xs: 2, sm: 2, md: 3, lg: 3 }}
      >
        <Stack direction="row" spacing={2} alignItems="center">
          <Location style={{ height: "30px", width: "30px" }} />
          <Typography
            sx={{ cursor: "pointer", maxWidth: "100%" }}
            onClick={openMap}
            fontFamily={"Poppins"}
            fontWeight={"400"}
            fontSize={{
              lg: "14px",
              md: "13px",
              sm: "12px",
              xs: "12px",
            }}
          >
            A-284, Shivalik, Malviya Nagar, Delhi - 110017
          </Typography>
        </Stack>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          sx={{ pr: { xs: 3, md: 3 } }}
        >
          <Contact style={{ height: "20px", width: "20px" }} />
          <Typography
            sx={{ cursor: "pointer" }}
            onClick={callPhone}
            fontFamily={"Poppins"}
            fontWeight={"400"}
            fontSize={{
              lg: "14px",
              md: "13px",
              sm: "12px",
              xs: "12px",
            }}
          >
            011-4056-4117
          </Typography>
        </Stack>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          sx={{ pr: { xs: 3, md: 3 } }}
        >
          <Email style={{ height: "20px", width: "20px" }} />
          <Typography
            sx={{ cursor: "pointer" }}
            onClick={sendEmail}
            fontFamily={"Poppins"}
            fontWeight={"400"}
            fontSize={{
              lg: "14px",
              md: "13px",
              sm: "12px",
              xs: "12px",
            }}
          >
            info@dxai.life
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
}
